import React, { useEffect, useRef } from "react";
import './css/app1.css';
import test from './icons/testimonial.png'

export default function Testimonials() {
  const testimonialsData = [
    {
      index: 1,
      avatar: test,
      text: "Raj Digital Marketing had made a huge impact to our business with the ork they had carried in order to build our presence.",
      author: "Bilal",
      role: "CEO"
    },
    {
      index: 2,
      avatar: "https://via.placeholder.com/100",
      text: "Found them online, via google. And since then there was no looking back.",
      author: "Shabbir",
      role: "Owner"
    },
    {
      index: 3,
      avatar: "https://via.placeholder.com/100",
      text: "The web design team at Raj Digital are very flexible with the work assigned to them and the delivery of the project.",
      author: "Oliver Kay",
      role: "Operational Manager"
    },
    {
      index: 4,
      avatar: "https://via.placeholder.com/100",
      text: " Raj Digital transformed our online presence — traffic and leads doubled in 3 months!",
      author: "Anita S ",
      role: "Fashion Brand Owner "
    },
    {
      index: 5,
      avatar: "https://via.placeholder.com/100",
      text: "Professional, responsive, and results-driven. Best marketing partner we’ve worked with ",
      author: "Rahul M ",
      role: "Tech Startup Founde "
    },
    {
      index: 6,
      avatar: "https://via.placeholder.com/100",
      text: "Their SEO service put us on the first page of Google — exactly what we needed! ",
      author: "Priya T ",
      role: " Event Planner"
    },
    {
      index: 7,
      avatar: "https://via.placeholder.com/100",
      text: "Creative social media campaigns that actually convert — highly recommend",
      author: "Vikas G",
      role: "Restaurant Chain Owner"
    },
    {
      index: 8,
      avatar: "https://via.placeholder.com/100",
      text: "Our new website is sleek, fast, and customers love it. Great job, Raj Digital! ",
      author: "Neha K ",
      role: "Boutique Store Owner"
    },
    {
      index: 9,
      avatar: "https://via.placeholder.com/100",
      text: "We saw a 3x return on ad spend within weeks. Impressive strategy and execution.",
      author: "Sameer D",
      role: "E-commerce Manage"
    },
    {
      index: 10,
      avatar: "https://via.placeholder.com/100",
      text: "Raj Digital is like an extension of our own team — they truly care about our growth",
      author: "Meena R",
      role: "Coaching Consultant"
    },

  ];

  const testimonialsSectionRef = useRef(null);

  useEffect(() => {
    const testimonialsSection = testimonialsSectionRef.current;
    const testimonials = testimonialsSection.querySelectorAll(".testimonial-card");

    const highlightTestimonial = () => {
      const scrollTop = testimonialsSection.scrollTop;
      const scrollBottom = scrollTop + testimonialsSection.clientHeight;

      testimonials.forEach((testimonial) => {
        const rect = testimonial.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= testimonialsSection.clientHeight) {
          testimonial.classList.add("highlighted");
        } else {
          testimonial.classList.remove("highlighted");
        }
      });
    };

    // Initial call to highlight testimonials on page load
    highlightTestimonial();

    // Listen for scroll events within testimonialsSection
    testimonialsSection.addEventListener("scroll", highlightTestimonial);

    // Cleanup event listener on component unmount
    return () => {
      testimonialsSection.removeEventListener("scroll", highlightTestimonial);
    };
  }, []);

  return (
    <div className="testimonialMain">
    <div className="container testimonialMain">
      <section className="testimonials-section" ref={testimonialsSectionRef}>
        <div className="testimonials">
          {testimonialsData.map((testimonial) => (
            <div className="testimonial-card" data-index={testimonial.index} key={testimonial.index}>
              <img className="tes-avatar" src={test} alt="User " />
              <div className="testimonial-content">
                <p className="testimonial-text">{testimonial.text}</p>
                <p className="testimonial-author">{testimonial.author}</p>
                <p className="testimonial-role">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      <section className="cta-section" style={{ width: "70%" }}>
        <div className="testitem1">
        <h5>TESTIMONIALS</h5>
        </div>
        <div className="testitemHeading">
        <h2>GROW YOUR BUSINESS
        WITH RAJ</h2>
        </div>
        <div className="testitemPara">
        <p>
        At Raj Digital Marketing, we are committed to delivering outstanding results that help businesses thrive in the competitive digital landscape. Our expertise in SEO, social media marketing, PPC advertising, and content creation has empowered countless brands to expand their reach, boost engagement, and drive conversions.
        </p>
        </div>
        <div className="testitemPara2">
        <p className="clients-interaction"><h5>450+ </h5>Clients Interaction</p>
        </div>
        <div className="testitembtn">
        <button id="viewMoreButton">View More</button>
        </div>
      </section>
    </div>
    </div>
  );
}
